import { render, staticRenderFns } from "./UiFieldSelect.vue?vue&type=template&id=3f2226ae"
import script from "./UiFieldSelect.vue?vue&type=script&lang=js"
export * from "./UiFieldSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports